import type { ContactAreaFeatureConfig } from './type';

export const AT: Partial<ContactAreaFeatureConfig> = {
    showSupportChatSection: false,
};
